export default "__VITE_ASSET__BSjRf3fP__"